export default __webpack_public_path__ + "static/media/card3.976e35f3.jpg";